import { render, staticRenderFns } from "./GroupMobileRestaurants.vue?vue&type=template&id=62bf5a58"
import script from "./GroupMobileRestaurants.vue?vue&type=script&lang=js"
export * from "./GroupMobileRestaurants.vue?vue&type=script&lang=js"
import style0 from "./GroupMobileRestaurants.vue?vue&type=style&index=0&id=62bf5a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports